(() => {
  if (window.DXAvailability) return;

  const availabilityParameter = 'filter.v.availability';

  function preferenceKey() {
    const params = new URLSearchParams(window.location.search);
    return `dx-ignite-stock:${window.location.pathname}:${params.get('q') || ''}:${params.get('type') || ''}`;
  }

  function remember(searchParams) {
    const values = new URLSearchParams(searchParams)
      .getAll(availabilityParameter)
      .flatMap(value => value.split(','));
    const preference = values.length === 1 && values[0] === '1' ? 'in-stock' : 'all';
    try {
      window.sessionStorage.setItem(preferenceKey(), preference);
    } catch {}
  }

  function applyDefault() {
    if (window.Shopify?.designMode || !document.getElementById('ProductGridContainer')) return;
    if (!document.querySelector('facet-filters-form input[name="filter.v.availability"][value="1"]')) return;

    const url = new URL(window.location.href);
    const types = url.searchParams.get('type');
    if (types && !types.split(',').includes('product')) return;

    if (url.searchParams.has(availabilityParameter)) {
      remember(url.searchParams);
      return;
    }

    try {
      if (window.sessionStorage.getItem(preferenceKey()) === 'all') return;
    } catch {}

    url.searchParams.set(availabilityParameter, '1');
    url.searchParams.delete('page');
    window.location.replace(url.toString());
  }

  window.DXAvailability = Object.freeze({ remember });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDefault, { once: true });
  } else {
    applyDefault();
  }
})();
